import { Mark } from "../components/icons.js";

/**
 * The whole access model, on one screen: one allow-listed GitHub account. There is
 * no sign-up, no password reset and no second user.
 */
export function SignInPage({ error }: { error?: string | null }) {
  return (
    <div className="signin">
      <Mark />
      <h1>Mosaic</h1>
      <p>Special-situations research, assembled from EDGAR.</p>
      {error && <p className="err">{error}</p>}
      <a className="go" href="/api/auth/login">
        Sign in with GitHub
      </a>
      <p className="hint" style={{ fontSize: 12, color: "var(--ink-3)" }}>
        One allow-listed account. There is no sign-up.
      </p>
    </div>
  );
}
